import { Controller } from "@hotwired/stimulus"

// Abre un <dialog> nativo cuando el partial se inyecta en el turbo-frame
// "modal" global del layout admin. Al cerrar el dialog, limpia el frame
// para que un nuevo modal pueda abrirse sin contenido residual.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    if (typeof this.dialogTarget.showModal === "function") {
      this.dialogTarget.showModal()
    }
  }

  close() {
    this.dialogTarget.close()
  }

  clickBackdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  closed() {
    const frame = this.element.closest("turbo-frame")
    if (frame) frame.innerHTML = ""
  }
}
